/** Portable filenames shared by the Agent SDK and browser-side bundle upload. */
export const AGENT_AVATAR_FILE = 'avatar.png';
export const AGENT_AVATAR_REF = `./${AGENT_AVATAR_FILE}`;
